import React from 'react'
import { ProSidebar, Menu, MenuItem, SidebarHeader, SidebarFooter } from 'react-pro-sidebar'
import 'react-pro-sidebar/dist/css/styles.css'
import './sidebar.scss'
import { Link, Outlet } from 'react-router-dom'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import { Container, Image, Nav, Navbar } from 'react-bootstrap'
import { observer } from 'mobx-react-lite'
import { Button } from '@mui/material'
import { useStore } from '../stores/store'

const SidebarD = () => {
  const { userStore } = useStore()
  const { getData, logout } = userStore

  return (
    <>
      <div className='app sidebar-res'>
        <ProSidebar image='https://www.xtrafondos.com/wallpapers/vertical/kylo-ren-fanart-5558.jpg'>
          <SidebarHeader className='d-flex pt-4 flex-column align-items-center'>
            <Image
              src={
                getData.gender === 1
                  ? '/images/avatar/avatar1.png'
                  : getData.gender === 0
                    ? '/images/avatar/avatar2.png'
                    : getData.gender === 2
                      ? '/images/avatar/avatar3.png'
                      : '/images/avatar/avatar1.png'
              }
              rounded
              style={{ width: '100px' }}
            />
            <h5 className='pt-2 pb-2'>{getData.firstName}</h5>
          </SidebarHeader>
          <Menu iconShape='square'>
            <MenuItem>
              Home
              <Link to='/' />
            </MenuItem>
            <MenuItem>
              Dashboard
              <Link to='/dashboard' />
            </MenuItem>
            {userStore.isAdministrator && (
              <MenuItem>
                User List
                <Link to='userList' />
              </MenuItem>
            )}
          </Menu>
          <SidebarFooter className='sidebarfooter'>
            <Button variant='contained' className='buttonLogin' onClick={logout}>
              Log out
            </Button>
          </SidebarFooter>
        </ProSidebar>
        <Outlet />
      </div>
      <div className='navbarRes'>
        <Navbar collapseOnSelect fixed='top' expand='lg' className='navbar' variant='dark'>
          <Container>
            <Navbar.Brand className='navTitle' as={Link} to='/'>
              <PlayCircleOutlineIcon fontSize='large' />
              TALSTREAM
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='basic-navbar-nav' />
            <Navbar.Collapse id='basic-navbar-nav'>
              <Nav className='me-auto'>
                <Nav.Link as={Link} to='/'>
                  Home
                </Nav.Link>
                <Nav.Link as={Link} to='/dashboard'>
                  Dashboard
                </Nav.Link>
                <Nav.Link as={Link} to='userList'>
                  User List
                </Nav.Link>
                <Nav.Link href='#link'>
                  <Button variant='contained' className='buttonLogin' onClick={logout}>
                    Log out
                  </Button>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Outlet />
      </div>
    </>
  )
}
export default observer(SidebarD)
